import { Observable, observe, Scope } from 'wdc-cube'

export type CompanyPartner = {
    CpfCnpj: string
    Nome: string
    Qualificacao: string
    QualificacaoRepresentanteLegal: string
}

export type CompanyRow = {
    CnpjCpf: string
    Nome: string
    NomeFantasia: string
    Porte: 'MICRO' | 'PEQUENA' | 'GRANDE' | 'MEDIA' | 'DEMAIS'
    ReceitaSituacao: 'NULA' | 'ATIVA' | 'SUSPENSA' | 'INAPTA' | 'BAIXADA' | 'NULA' | 'NULA'
    VaduAtividadeCNAE: string
    Telefones: string[]
    Emails: string[]
    Socios: CompanyPartner[]
    Filiais: string[]
    ReceitaMotivoSituacao: string
    ReceitaDataSituacao: string
    ReceitaAbertura: string
    ReceitaNaturezaJuridica: string
    ReceitaSituacaoEspecial: string
    ReceitaDataSituacaoEspecial: string
    ReceitaCapitalSocial: number
    ReceitaAtividade: string
    ReceitaAtividadeSecundaria: string
    SimplesNacional: boolean
    SimplesNacionalDataConsulta: string
    CodigoMEI: boolean
    CodigoMEIDataConsulta: string
    Logradouro: string
    NumeroLogradouro: string
    ComplementoEndereco: string
    BairroEndereco: string
    MunicipioEndereco: string
    UfEndereco: string
    CepEnderecoFormatado: string
    CodIbge: string
    TelefonePrincipal: string
    EmailPrincipal: string
    Site: string
    qtdFunc: number
    // :: Matriz
    ReceitaTipo: 'MATRIZ' | 'FILIAL'
    CnpjMatriz: string
    ReceitaMatrizCapitalSocial: number
    qtdFuncMatriz: number
}

@Observable
export class HeaderScope extends Scope {}

@Observable
export class PJScope extends Scope {
    readonly header = new HeaderScope()

    @observe() company = [] as CompanyRow[]
    @observe() cnpjSelected = '' as string

    onFind = Scope.ASYNC_ACTION
}

export default PJScope
